var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"text":"","color":_vm.color},on:{"click":function($event){return _vm.gotoTask()}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"primary","dense":"","small":""}},[_vm._v(" mdi-checkbox-marked-circle-outline ")]),_vm._v(" "+_vm._s(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }